import { ReactElement } from "react";
import { useViewProvider } from "../../contexts/view-provider-context/ViewProvider";

export function NoVwVehicleModalContent(): ReactElement {
  const viewProvider = useViewProvider();

  return viewProvider.renderNoVwVehicleModalContent();
}
